export default __webpack_public_path__ + "static/media/lkdin.552af841.svg";